import React from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import "./addSchool.css";


export default function AddSchool() {
  const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm();

  const onSubmit = async (data) => {
    const formData = new FormData();
    for (const key in data) {
      if (key !== "image") formData.append(key, data[key]);
    }
    if (data.image && data.image[0]) {
      formData.append("image", data.image[0]);
    }

    try {
      await axios.post("http://localhost:5000/addSchool", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      alert("School added successfully!");
      reset();
    } catch (e) {
      alert("Failed to add school");
      console.error(e);
    }
  };

  return (
    <div className="container" style={{ maxWidth: 560, margin: "20px auto", padding: 16 }}>
      <h2 className="form-title">Add School</h2>
      <form className="school-form" onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <label>School Name</label>
        <input className="input-field" {...register("name", { required: "Name is required" })} />
        {errors.name && <small>{errors.name.message}</small>}

        <label>Address</label>
        <input className="input-field" {...register("address", { required: "Address is required" })} />
        {errors.address && <small>{errors.address.message}</small>}

        <label>City</label>
        <input className="input-field" {...register("city", { required: "City is required" })} />
        {errors.city && <small>{errors.city.message}</small>}

        <label>State</label>
        <input {...register("state", { required: "State is required" })} />
        {errors.state && <small>{errors.state.message}</small>}

        <label>Contact</label>
        <input className="input-field"
          {...register("contact", {
            required: "Contact is required",
            pattern: { value: /^[0-9]{10}$/, message: "Enter 10 digit number" },
          })}
        />
        {errors.contact && <small>{errors.contact.message}</small>}

        <label>Email</label>
        <input className="input-field"
          {...register("email_id", {
            required: "Email is required",
            pattern: { value: /^\S+@\S+$/i, message: "Enter valid email" },
          })}
        />
        {errors.email_id && <small>{errors.email_id.message}</small>}

        <label>School Image</label>
        <input className="input-field" type="file" accept="image/*" {...register("image", { required: "Image is required" })} />
        {errors.image && <small>{errors.image.message}</small>}

        <button className="btn-submit" disabled={isSubmitting} style={{ marginTop: 12 }} type="submit">
          {isSubmitting ? "Saving..." : "Add School"}
        </button>
      </form>
    </div>
  );
}
